module.exports = __webpack_public_path__ + "img/FLSH4.81e9e782.svg";